/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ week: NonNullable<unknown>, day: NonNullable<unknown> }} Caring_Best_Poodle_ComfortInputs */

const fr_caring_best_poodle_comfort = /** @type {(inputs: Caring_Best_Poodle_ComfortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semaine ${i?.week}, Jour ${i?.day}`)
};

/**

* @param {Caring_Best_Poodle_ComfortInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const caring_best_poodle_comfort = /** @type {((inputs: Caring_Best_Poodle_ComfortInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caring_Best_Poodle_ComfortInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_caring_best_poodle_comfort(inputs)
});